import React, { useEffect, useState } from "react";
import { supabase } from "../services/supabase";

const PAGE_SIZE = 15;

const DriversPage = () => {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(null);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [vehicleModal, setVehicleModal] = useState(null);

  // 🔍 Recherche + pagination
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  const [editingDriverId, setEditingDriverId] = useState(null);
const [tempNum, setTempNum] = useState("");

  // Charger chauffeurs (inchangé)
  const loadDrivers = async () => {
    setLoading(true);

    const { data, error } = await supabase
      .from("drivers")
      .select(`
        id,
        num_driver,
        status,
        is_active,
        approved,
        created_at,
        profiles:profiles(full_name, phone, email),
        vehicles:vehicles!vehicles_driver_id_fkey(brand, model, plate, color, year),
        documents:driver_documents!driver_documents_id_fkey(
          permis_url,
          permisChauffeurAutorise_url,
          autorisationVehicule_url,
          preuve_paiement_url,
          tps,
          tvq,
          sev,
          permis_expiration
        )
      `);

    if (error) {
      console.error("Erreur load drivers:", error);
    } else {
      setDrivers(data);
    }

    setLoading(false);
  };

  useEffect(() => {
    loadDrivers();
  }, []);

  // 🔥 Debug conservé
  useEffect(() => {
    console.log("Drivers loaded:", drivers);
  }, [drivers]);

  // ===== ACTIONS (INCHANGÉES) =====
  const approveDriver = async (driverId) => {
    setActionLoading(driverId);
    await supabase.from("drivers").update({ approved: true }).eq("id", driverId);
    loadDrivers();
    setActionLoading(null);
  };

  const blockDriver = async (driverId) => {
    setActionLoading(driverId);
    await supabase.from("drivers").update({ is_active: false }).eq("id", driverId);
    loadDrivers();
    setActionLoading(null);
  };

  const activateDriver = async (driverId) => {
    setActionLoading(driverId);
    await supabase.from("drivers").update({ is_active: true }).eq("id", driverId);
    loadDrivers();
    setActionLoading(null);
  };

  //Reset Password
  const resetDriverPassword = async (driverId) => {

    // 🔐 CONFIRMATION ADMIN
  if (!window.confirm("Confirmer le reset du mot de passe de ce chauffeur ?")) {
    return;
  }

  const newPassword = prompt(
    "Nouveau mot de passe (min 8 caractères)"
  );

  if (!newPassword || newPassword.length < 8) {
    alert("Mot de passe invalide");
    return;
  }

  const { error } = await supabase.functions.invoke(
  "admin-reset-password",
  {
    body: { driverId, newPassword },
  }
);

if (error) {
  alert("Erreur : " + error.message);
  return;
}

alert("Mot de passe modifié avec succès");
};


  const updateNumDriver = async (driverId, newNumber) => {
    if (!newNumber || isNaN(newNumber)) {
      alert("Numéro invalide");
      return;
    }

    const { error } = await supabase
      .from("drivers")
      .update({ num_driver: newNumber })
      .eq("id", driverId);

    if (error) {
      console.error(error);
      alert("Erreur lors de l'enregistrement");
    } else {
      await loadDrivers();
    }
  };

  // ===== 🔍 FILTRAGE CLIENT-SIDE =====
  const filteredDrivers = drivers.filter((d) => {
    const q = search.toLowerCase();
    return (
      d.profiles?.full_name?.toLowerCase().includes(q) ||
      d.profiles?.phone?.toLowerCase().includes(q) ||
      d.profiles?.email?.toLowerCase().includes(q) ||
      String(d.num_driver || "").includes(q)
    );
  });

  // ===== 📄 PAGINATION CLIENT-SIDE =====
  const totalPages = Math.ceil(filteredDrivers.length / PAGE_SIZE);
  const paginatedDrivers = filteredDrivers.slice(
    (page - 1) * PAGE_SIZE,
    page * PAGE_SIZE
  );

  const openDocument = async (storedValue) => {
  if (!storedValue) {
    alert("Document introuvable");
    return;
  }

  let path = storedValue;

  // 🧠 Si une URL complète est stockée → extraire le path
  if (storedValue.startsWith("http")) {
    const marker = "/driver-documents/";
    const index = storedValue.indexOf(marker);

    if (index === -1) {
      alert("URL invalide");
      return;
    }

    path = storedValue.substring(index + marker.length);
  }

  console.log("📂 STORAGE PATH:", path);

  const { data, error } = await supabase.storage
    .from("driver-documents")
    .createSignedUrl(path, 60 * 10);

  if (error || !data?.signedUrl) {
    console.error("SIGNED URL ERROR:", error);
    alert("Impossible d’ouvrir le document");
    return;
  }

  window.open(data.signedUrl, "_blank");
};




  return (
    <div>
      <h2>Chauffeurs</h2>

      {/* 🔍 BARRE DE RECHERCHE (AJOUTÉE) */}
      <div style={{ marginBottom: "15px" }}>
        <input
          type="text"
          placeholder="Rechercher (nom, téléphone, email, numéro)"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
          style={{
            width: "320px",
            padding: "8px",
            borderRadius: "6px",
            border: "1px solid #ccc",
          }}
        />
      </div>

      {loading ? (
        <p>Chargement...</p>
      ) : paginatedDrivers.length === 0 ? (
        <p>Aucun chauffeur trouvé.</p>
      ) : (
        <>
          <table className="table">
            <thead>
              <tr>
                <th>Nom</th>
                <th>Téléphone</th>
                <th>Email</th>
                <th>Numéro</th>
                <th>Statut</th>
                <th>Approuvé</th>
                <th>Compte</th>
                <th>Véhicule</th>
                <th>Documents</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {paginatedDrivers.map((driver) => (
                <tr key={driver.id}>
                  <td>
                    <span style={{ fontWeight: "bold", color: "#444" }}>
                      {driver.num_driver ? `#${driver.num_driver}` : "—"}
                    </span>{" "}
                    · {driver.profiles?.full_name || "---"}
                  </td>

                  <td>{driver.profiles?.phone || "---"}</td>
                  <td>{driver.profiles?.email || "---"}</td>

                  <td style={{ whiteSpace: "nowrap" }}>
                {editingDriverId === driver.id ? (
                    <>
                    <input
                        type="number"
                        min="1"
                        value={tempNum}
                        onChange={(e) => setTempNum(e.target.value)}
                        style={{
                        width: "70px",
                        padding: "4px",
                        borderRadius: "4px",
                        border: "1px solid #ccc",
                        textAlign: "center",
                        }}
                    />

                    <button
                        className="validation-sec"
                        style={{ marginLeft: "6px" }}
                        onClick={async () => {
                        await updateNumDriver(driver.id, tempNum);
                        setEditingDriverId(null);
                        }}
                    >
                        ✔️
                    </button>

                    <button
                        className="validation-prim"
                        style={{ marginLeft: "4px" }}
                        onClick={() => setEditingDriverId(null)}
                    >
                        ✖️
                    </button>
                    </>
                ) : (
                    <>
                    <span style={{ marginRight: "6px", fontWeight: "600" }}>
                        {driver.num_driver || "—"}
                    </span>

                    <button
                        className="validation-sec"
                        onClick={() => {
                        setEditingDriverId(driver.id);
                        setTempNum(driver.num_driver || "");
                        }}
                    >
                        ✏️
                    </button>
                    </>
                )}
                </td>


                  <td>
                    {driver.status === "online" && (
                      <span className="status-green">En ligne</span>
                    )}
                    {driver.status === "busy" && (
                      <span className="status-yellow">Occupé</span>
                    )}
                    {driver.status === "offline" && (
                      <span className="status-red">Hors ligne</span>
                    )}
                  </td>

                  <td>
                    {driver.approved ? (
                      <span className="approved-green">Oui</span>
                    ) : (
                      <span className="approved-red">Non</span>
                    )}
                  </td>

                  <td>
                    {driver.is_active ? (
                      <span className="active-green">Actif</span>
                    ) : (
                      <span className="active-red">Bloqué</span>
                    )}
                  </td>

                  <td>
                    {driver.vehicles?.[0] ? (
                      <button
                        className="btn-secondary"
                        style={{ marginTop: "6px" }}
                        onClick={() => setVehicleModal(driver)}
                      >
                        Voir véhicule
                      </button>
                    ) : (
                      <span style={{ color: "#999" }}>Aucun véhicule</span>
                    )}
                  </td>

                  <td>
                    <button
                      className="btn-secondary"
                      onClick={() => setSelectedDriver(driver)}
                    >
                      Voir Documents
                    </button>
                  </td>

                  <td>
                    {!driver.approved && (
                      <button
                        className="btn-primary"
                        disabled={actionLoading === driver.id}
                        onClick={() => approveDriver(driver.id)}
                      >
                        Approuver
                      </button>
                    )}

                    {driver.is_active ? (
                      <button
                        className="btn-danger"
                        disabled={actionLoading === driver.id}
                        onClick={() => blockDriver(driver.id)}
                      >
                        Bloquer
                      </button>
                    ) : (
                      <button
                        className="btn-secondary"
                        disabled={actionLoading === driver.id}
                        onClick={() => activateDriver(driver.id)}
                      >
                        Activer
                      </button>
                    )}

                    <button
                    className="btn-reset-password"
                    title="Réinitialiser le mot de passe du chauffeur"
                    onClick={() => resetDriverPassword(driver.id)}
                  >
                    Reset mot de passe
                  </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* 📄 PAGINATION (AJOUTÉE) */}
          {totalPages > 1 && (
            <div className="pagination">
              <button
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
              >
                ← Précédent
              </button>
              <span>
                Page {page} / {totalPages}
              </span>
              <button
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
              >
                Suivant →
              </button>
            </div>
          )}
        </>
      )}

      {/* ===== MODAL DOCUMENTS ===== */}
{selectedDriver && (
  <div className="modal-backdrop">
    <div className="modal-card">
      <h3>Documents du chauffeur</h3>

      <p><strong>TPS :</strong> {selectedDriver.documents?.tps || "—"}</p>
      <p><strong>TVQ :</strong> {selectedDriver.documents?.tvq || "—"}</p>
      <p><strong>SEV :</strong> {selectedDriver.documents?.sev || "—"}</p>

      <p>
        <strong>Expiration permis :</strong>{" "}
        {selectedDriver.documents?.permis_expiration || "—"}
      </p>

      <hr />

      {/* PERMIS DE CONDUIRE */}
      <p><strong>Permis de conduire :</strong></p>
      {selectedDriver.documents?.permis_url ? (
        <button
          className="btn-link"
          onClick={() =>
            openDocument(selectedDriver.documents.permis_url)
          }
        >
          Voir le permis
        </button>
      ) : (
        <span>Aucun</span>
      )}

      {/* PERMIS CHAUFFEUR AUTORISÉ */}
      <p><strong>Permis chauffeur autorisé :</strong></p>
      {selectedDriver.documents?.permisChauffeurAutorise_url ? (
        <button
          className="btn-link"
          onClick={() =>
            openDocument(
              selectedDriver.documents.permisChauffeurAutorise_url
            )
          }
        >
          Voir le permis chauffeur autorisé
        </button>
      ) : (
        <span>Aucun</span>
      )}

      {/* AUTORISATION VÉHICULE */}
      <p><strong>Autorisation du véhicule :</strong></p>
      {selectedDriver.documents?.autorisationVehicule_url ? (
        <button
          className="btn-link"
          onClick={() =>
            openDocument(
              selectedDriver.documents.autorisationVehicule_url
            )
          }
        >
          Voir l'autorisation du véhicule
        </button>
      ) : (
        <span>Aucun</span>
      )}

      {/* PREUVE DE PAIEMENT */}
      <p><strong>Preuve de paiement :</strong></p>
      {selectedDriver.documents?.preuve_paiement_url ? (
        <button
          className="btn-link"
          onClick={() =>
            openDocument(
              selectedDriver.documents.preuve_paiement_url
            )
          }
        >
          Voir la preuve de paiement
        </button>
      ) : (
        <span>Aucun</span>
      )}

      <div style={{ marginTop: "20px", textAlign: "right" }}>
        <button
          className="btn-danger"
          onClick={() => setSelectedDriver(null)}
        >
          Fermer
        </button>
      </div>
    </div>
  </div>
)}



      {vehicleModal && (
        <div className="modal-backdrop">
          <div className="modal-card" style={{ maxWidth: "500px" }}>
            <h3>Véhicule du chauffeur</h3>

            <p><strong>Marque :</strong> {vehicleModal.vehicles[0].brand || "—"}</p>
            <p><strong>Modèle :</strong> {vehicleModal.vehicles[0].model || "—"}</p>
            <p><strong>Année :</strong> {vehicleModal.vehicles[0].year || "—"}</p>
            <p><strong>Plaque :</strong> {vehicleModal.vehicles[0].plate || "—"}</p>
            <p><strong>Couleur :</strong> {vehicleModal.vehicles[0].color || "—"}</p>

            <div style={{ marginTop: "15px", textAlign: "right" }}>
              <button className="btn-danger" onClick={() => setVehicleModal(null)}>
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DriversPage;


